import React from "react";
import SearchIcon from '@material-ui/icons/Search'


export function ChatSearchbar(props) {
  const { filter } = props;
  return (
    <div className="chat-searchbar">
      <div className="prepend-icon ">
        <SearchIcon />
      </div>
      <input className="input-field" onChange={(e) => filter(e.target.value)} />
    </div>
  );
}
